import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function GetSupport() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const notify = () => toast.success("Request submitted successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", name);
        formData.append("email", email);
        formData.append("message", message);

        axios.post("https://bntserver.bntfoundation.com/SupportAdd.php", formData)
            .then((res) => {
                notify();
                setName("");
                setEmail("");
                setMessage("");
            })
            .catch((err) => {
                console.log(err);
                toast.error("Something went wrong. Please try again later.");
            });
    };

    return (
        <div>
            <ToastContainer />
            {/* HERO */}
            <div
                className="hero page-inner overlay"
                style={{ backgroundImage: `url('../../Content/img/slide/BNT5.jpg')` }}
            >
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-9 text-center mt-5">
                            <h1 className="heading">Get Support</h1>
                            <p className="text-white mt-3">You are not alone.</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* MAIN */}
            <div className="container py-5">
                <div className="row">

                    {/* LEFT INFO */}
                    <div className="col-lg-5 mb-4">

                        <div className="supportCard">
                            <h4 className="mb-3">Reach Out</h4>

                            <p className="text-gray">
                                If you or someone you know is struggling, we are here to listen and support you.
                            </p>

                            <div className="mt-4">
                                <p><strong>Email:</strong><br />seva@babananaktrust.ca</p>
                                <p><strong>Phone:</strong><br />780-616-5057</p>
                            </div>

                            <hr />

                            <p className="text-danger small mt-3">
                                If you are in immediate danger or need urgent help, please contact your local emergency services right away.
                            </p>
                        </div>

                    </div>

                    {/* RIGHT FORM */}
                    <div className="col-lg-7">

                        <div className="supportFormCard">

                            <h4 className="mb-4">Send Us a Message</h4>

                            <form onSubmit={handleSubmit}>

                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Your Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Your Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col-12 mb-3">
                                        <textarea
                                            className="form-control"
                                            rows="5"
                                            placeholder="How can we help you?"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="col-12">
                                        <button className="btn btn-secondary px-4 py-2" type="submit">
                                            Submit Request
                                        </button>
                                    </div>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}

export default GetSupport;